import { createSvgIcon } from '@material-ui/core/utils';
import { jsx as _jsx } from "react/jsx-runtime";
export default createSvgIcon( /*#__PURE__*/_jsx("path", {
  d: "M20.414 13.711h-6.482v6.539h-3.558v-6.539H3.586l8.409-9.961 8.42 9.961z"
}), 'LongArrowUp');